var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsEnum, IsString, IsUUID } from 'class-validator';
import { SubscriptionInterval } from '../enum/SubscriptionInterval.enum.js';
import { SubscriptionStatus } from '../enum/subscription-status.enum.js';
export class SubscriptionResponseDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    subscriptionStripeId;
    endingOn;
    cancelAt;
    isTrialPeriod;
    isPaused;
    status;
    rawData;
    interval;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], SubscriptionResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], SubscriptionResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], SubscriptionResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], SubscriptionResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    IsString(),
    Exclude(),
    __metadata("design:type", String)
], SubscriptionResponseDto.prototype, "subscriptionStripeId", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], SubscriptionResponseDto.prototype, "endingOn", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], SubscriptionResponseDto.prototype, "cancelAt", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], SubscriptionResponseDto.prototype, "isTrialPeriod", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], SubscriptionResponseDto.prototype, "isPaused", void 0);
__decorate([
    IsEnum(SubscriptionStatus),
    Expose(),
    __metadata("design:type", String)
], SubscriptionResponseDto.prototype, "status", void 0);
__decorate([
    IsString(),
    Exclude(),
    __metadata("design:type", Object)
], SubscriptionResponseDto.prototype, "rawData", void 0);
__decorate([
    IsEnum(SubscriptionInterval),
    Expose(),
    __metadata("design:type", Object)
], SubscriptionResponseDto.prototype, "interval", void 0);
//# sourceMappingURL=subscription.response.dto.js.map